/**
 * @flow
 */

import styled from 'react-emotion'
import colors from '../../../themes/Colors'
import { BaseDinDemi } from '../../../themes/Fonts/Din2014'
import Button from '../../Button'

export const ButtonContainer = styled(Button)`
  border-radius: 0.125em;
  background-color: ${colors.tangerineThree};
  padding: 0.875em 2.5em;
  border: none;
  @media (max-width: 767px) {
    font-size: 1em;
    padding: 1em 2.857em;
    border-radius: 0.143em;
  }
`

export const ButtonText = styled(BaseDinDemi)`
  font-size: 0.875em;
  line-height: normal;
  letter-spacing: normal;
  color: ${colors.whiteTwo};
  margin-right: 0.625em;
  @media (max-width: 767px) {
    font-size: 1em;
    margin-right: 0.714em;
  }
`



// WEBPACK FOOTER //
// ./src/components/IbcArcade/ButtonComponent/styledComponents.js